import { render } from "./GlTableTwoColumns.vue?vue&type=template&id=22c21ab4&scoped=true"
import script from "./GlTableTwoColumns.vue?vue&type=script&lang=js"
export * from "./GlTableTwoColumns.vue?vue&type=script&lang=js"

import "./GlTableTwoColumns.vue?vue&type=style&index=0&id=22c21ab4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22c21ab4"

export default script